import { CadstromObjectType, isCadstromUidOfType } from '@cadstrom/cadstrom-shared';

/**
 * Reports whether a pair of route params can address a conversation page.
 *
 * @param ownerId - Candidate owner id; valid only for a user or organization.
 * @param conversationId - Candidate conversation id.
 * @returns True when the owner is a user or organization and the conversation id
 *   is a well-formed agent-workbench conversation id.
 */
export function isValidAgentConversationRoute(ownerId: string, conversationId: string): boolean {
	const validOwner =
		isCadstromUidOfType(ownerId, CadstromObjectType.User) ||
		isCadstromUidOfType(ownerId, CadstromObjectType.Organization);
	return validOwner && isCadstromUidOfType(conversationId, CadstromObjectType.AgentChatConversation);
}
